import { Box, Divider, Flex, Icon, Small, Text } from "orcs-design-system";

import useWorkspaceDateFormats from "src/hooks/useWorkspaceDateFormats";

import { formatWorkspaceStamp, type HistoryRow } from "./guardrailHistoryRows";

const dateLine = (
  row: HistoryRow,
  formats: { readable: string; readableDateTime: string }
): string | null => {
  const formatted = formatWorkspaceStamp(row.at, row.atKind, formats);
  if (!formatted) {
    return null;
  }
  return row.datePrefix ? `${row.datePrefix} ${formatted}` : formatted;
};

const GuardrailHistory = ({ rows }: { rows: HistoryRow[] }) => {
  const formats = useWorkspaceDateFormats();
  if (rows.length === 0) {
    return null;
  }
  return (
    <Flex flexDirection="column" gap="s" data-testid="guardrail-history">
      <Small uppercase weight="bold" color="greyDark">
        History
      </Small>
      {rows.map((row, index) => {
        const when = dateLine(row, formats);
        return (
          <Flex key={row.id} flexDirection="column" gap="s">
            {index > 0 ? <Divider light /> : null}
            <Flex gap="s" alignItems="flex-start">
              <Flex
                alignItems="center"
                justifyContent="center"
                bg="greyLightest"
                borderRadius="50%"
                width="32px"
                height="32px"
                flexShrink={0}
              >
                <Icon icon={row.icon} variant="greyDark" aria-hidden="true" />
              </Flex>
              <Box minWidth="0">
                <Text>{row.title}</Text>
                {when ? (
                  <Small color="greyDark" display="block">
                    {when}
                  </Small>
                ) : null}
              </Box>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default GuardrailHistory;
